module.exports = __webpack_public_path__ + "media/baiwuranda.9b1c8fde.mp4";